import img_gadki from './assets/images/gallery/gallery-gadki/image1.jpg';
import img_poznan from './assets/images/gallery/gallery-poznan/image1.jpg';
import img_wroclaw from './assets/images/gallery/gallery-wroclaw/image1.jpg';
import img_kamionki from './assets/images/gallery/gallery-kamionki/image2.jpg';
import img_dentysta from './assets/images/gallery/gallery-dentysta/image1.jpg';
import img_photoshop
  from './assets/images/gallery/gallery-photoshop/image1.jpg';
import img_leszno from './assets/images/gallery/gallery-leszno/img10.jpg';

export default {
  galeries() {
    return [
      {
        img: img_gadki,
        title: 'Dom w Kamionkach',
        subtitle: 'Umeblowanie domu jednorodzinnego w gądkach',
        text: 'Projektant:',
        designer_url: '',
        designer_title: 'INWESTOR & FAHU MEBLE',
        slug: 'dom-kamionki',
      },
      {
        img: img_poznan,
        title: 'Mieszkanie w Poznaniu',
        subtitle: 'Umeblowanie mieszkania w Poznaniu',
        text: 'Projektant: ',
        designer_url: '',
        designer_title: 'INWESTOR & FAHU MEBLE',
        slug: 'poznan',
      },
      {
        img: img_wroclaw,
        title: 'Apartament we Wrocławiu',
        subtitle: 'Umeblowany apartament we Wrocławiu',
        text: 'Projektant:',
        designer_url: 'http://www.studiotektura.pl/',
        designer_title: 'Studio TEKTURA',
        slug: 'wroclaw',
      },
      {
        img: img_kamionki,
        title: 'Kuchnia w Kamionkach',
        subtitle: 'Wykonanie kuchni w domu bliźniaczym w Kamionkach',
        text: 'Projektant: ',
        designer_url: 'http://www.studiotektura.pl/',
        designer_title: 'Studio TEKTURA',
        slug: 'kuchnia-kamionki',
      },
      {
        img: img_dentysta,
        title: 'Gabinet stomatologiczny',
        subtitle: 'Gabinet stomatologiczny na osiedlu River Park',
        text: 'Projektant: ',
        slug: 'stomatolog-osiedle-river-park',
      },
      {
        img: img_photoshop,
        title: 'Dusseldorf Wonder Photo Shop',
        subtitle: 'FujiFilm Wonder Photo Shop, Dusseldorf ',
        text: 'Projektanci: ',
        designer_url: 'http://ostrowscydesign.pl/',
        designer_title: 'Ostrowscy Design',
        slug: 'dusseldorf-wonder-photo-shop',
      },
      {
        img: img_leszno,
        title: 'Dom w Lesznie',
        subtitle: 'Umeblowanie domu jednorodzinnego w Lesznie',
        text: 'Projektanci: ',
        // designer_url: 'http://ostrowscydesign.pl/',
        // designer_title: 'Ostrowscy Design',
        slug: 'dom-leszno',
      },
    ];
  },
};
